module.exports = function(match) {
  match('view/app', 'catalogue#index');
  match('view/app/index.html', 'catalogue#catalogue');
  return match('index.html', 'catalogue#catalogue');
};
